import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog'

export interface InfoDialogData {
  title: string
  message: string
}

@Component({
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './info-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './info-dialog.component.scss',
})
export class InfoDialogComponent {
  readonly data: InfoDialogData = inject(MAT_DIALOG_DATA)
}
